<div class="container mt-3">
  <!*--------------------------------------------- FILTERS--------------------------------------------->
  <!--    <span><strong> startDate {{startDate}} endDate {{endDate}} gender {{selectedGender}}-->
  <!--        centre {{selectedCentreCode}}</strong></span>-->
  <!--    <p>CASE {{case}}</p>-->

  &nbsp;&nbsp;<div class="row">
  <mat-form-field appearance="outline" class="col-md-4">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
      <input matEndDate [(ngModel)]="endDate" placeholder="End date" (dateChange)="onEndDateChanged()">
    </mat-date-range-input>
    <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>


  <!--  <mat-form-field appearance="outline" class="col-md-3">-->
  <!--    <mat-label>Select Centre</mat-label>-->
  <!--    <mat-select (selectionChange)="setSelectedCentreCode($event)" [(ngModel)]="selectedCentreCode">-->
  <!--      <mat-option value="All">All</mat-option>-->

  <!--      <mat-option *ngFor=" let c of (centres$|async) " [value]="c.centreCode">{{ c.centreName }}-->
  <!--      </mat-option>-->
  <!--    </mat-select>-->
  <!--  </mat-form-field>-->

  <mat-form-field appearance="outline" class="col-md-3">
    <mat-label>Select Centre(s)</mat-label>
    <mat-select multiple
                [(ngModel)]="selectedCentreCodes"
                (selectionChange)="onCentreSelect($event.value)">
      <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
        {{ c.centreName }}
      </mat-option>
    </mat-select>
    <mat-hint *ngIf="selectedCentreCodes.length === 0">No filter — all centres</mat-hint>
    <mat-hint *ngIf="selectedCentreCodes.length > 0">{{ selectedCentreCodes.length }} selected</mat-hint>
  </mat-form-field>


  <mat-form-field appearance="outline" class="col-md-2">
    <mat-label>Status</mat-label>
    <mat-select (selectionChange)="onSelectStatus($event)" [(ngModel)]="selectedStatus">
      <mat-option value="All">All</mat-option>
      <mat-option value="Discharged">Discharged</mat-option>
      <mat-option value="OM SHANTI">OM SHANTI</mat-option>
      <mat-option value="Staying">Staying</mat-option>
      <!--      <mat-option  value="All">All Centres</mat-option>-->
    </mat-select>
  </mat-form-field>
  <!*--------------------------------------------- GENDER --------------------------------------------->

  <mat-form-field appearance="outline" class="col-md-3">
    <mat-label>Gender</mat-label>
    <mat-select (selectionChange)="onSelectGender($event)" [(ngModel)]="selectedGender">
      <mat-option value="All">All</mat-option>

      <mat-option value="Female">Female</mat-option>
      <mat-option value="Male">Male</mat-option>
    </mat-select>
  </mat-form-field>

  <!*--------------------------------------------- Location --------------------------------------------->

  <mat-form-field appearance="outline" class="col-md-3">
    <mat-label>State</mat-label>

    <!--    <mat-select (selectionChange)="onSelectLocation($event)" [(ngModel)]="selectedLocation">-->
    <!--      <mat-option value="All">All</mat-option>-->
    <!--      <mat-option *ngFor="let s of StateNames" [value]=s.name>{{ s.name }}</mat-option>-->

    <!--    </mat-select>-->

    <mat-select (selectionChange)="onSelectLocation($event)" [(ngModel)]="selectedLocation"
                (opened)="filteredStates = filteredStates">

      <!-- SEARCH BOX -->
      <!--      <mat-option (click)="$event.stopPropagation()" class="no-select-option">-->
      <!--        <input matInput placeholder="Search..." [formControl]="stateSearchControl"-->
      <!--               autocomplete="off" (keydown)="$event.stopPropagation()">-->
      <!--      </mat-option>-->

      <mat-option class="no-select-option" (click)="$event.stopPropagation()">
        <div class="mat-select-search">
          <input
            matInput
            placeholder="Search child..."
            [formControl]="stateSearchControl"
            autocomplete="off"
            (keydown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
            (focus)="$event.stopPropagation()"
          />
        </div>
      </mat-option>

      <mat-option value="All">All</mat-option>
      <mat-option *ngFor="let s of filteredStates" [value]="s.name">{{ s.name }}</mat-option>

    </mat-select>

  </mat-form-field>

  <!*--------------------------------------------- Hospital
  --------------------------------------------->

  <mat-form-field appearance="outline" class="col-md-3">
    <mat-label>Hospital</mat-label>

<!--        <mat-select (selectionChange)="onSelectHospital($event)" [(ngModel)]="selectedHospital">-->
<!--          <mat-option value="All">All</mat-option>-->
<!--          <mat-option *ngFor="let h of (hospitals$|async)"-->
<!--                      [value]="h.hospitalName">{{ h.hospitalName }}-->
<!--          </mat-option>-->
<!--          &lt;!&ndash;                <mat-option value="Female">Female</mat-option>&ndash;&gt;-->
<!--        </mat-select>-->

    <mat-select (selectionChange)="onSelectHospital($event)" [(ngModel)]="selectedHospital"

                (opened)="resetHospitalFilter()">

      <mat-option class="no-select-option" (click)="$event.stopPropagation()">
        <div class="mat-select-search">
          <input matInput placeholder="Search..." [formControl]="hospitalSearchControl"
                 autocomplete="off"
                 (keydown)="$event.stopPropagation()"
                 (click)="$event.stopPropagation()"
                 (mousedown)="$event.stopPropagation()"
                 (focus)="$event.stopPropagation()"
          >
        </div>
      </mat-option>

      <mat-option value="All">All</mat-option>
      <mat-option *ngFor="let h of filteredHospitals" [value]="h.hospitalName">
        {{ h.hospitalName }}
      </mat-option>

    </mat-select>

  </mat-form-field>
  <mat-form-field appearance="outline" class="col-md-2">
    <mat-label>Type</mat-label>
    <mat-select [(ngModel)]="typeSelected">
      <mat-option *ngFor="let option of admissionTypes" [value]="option">
        {{ option }}
      </mat-option>
    </mat-select>
  </mat-form-field>


  <mat-form-field appearance="outline" class="col-md-2">
    <mat-label>Diagnosis</mat-label>
    <!--    <mat-select (selectionChange)="onDiagnosisSelect($event)" [(ngModel)]="selectedDiagnosis">-->
    <!--      <mat-option value="All">All</mat-option>-->
    <!--      <mat-option *ngFor="let d of (_diagnosis$|async)" [value]="d">{{ d }}</mat-option>-->
    <!--      &lt;!&ndash;                <mat-option value="Female">Female</mat-option>&ndash;&gt;-->
    <!--    </mat-select>-->


    <mat-select
      (selectionChange)="onDiagnosisSelect($event)"
      [(ngModel)]="selectedDiagnosis"
      (opened)="resetDiagnosisFilter()"
    >


    <mat-option class="no-select-option" (click)="$event.stopPropagation()">
        <div class="mat-select-search">
          <input matInput placeholder="Search..."
                 [formControl]="diagnosisSearchControl"
                 autocomplete="off"
                 (keydown)="$event.stopPropagation()"
                 (click)="$event.stopPropagation()"
                 (mousedown)="$event.stopPropagation()"
                 (focus)="$event.stopPropagation()"
          >
        </div>
      </mat-option>

      <mat-option value="All">All</mat-option>
      <mat-option *ngFor="let d of filteredDiagnosis" [value]="d">
        {{ d }}
      </mat-option>

    </mat-select>


  </mat-form-field>

  <!*--------------------------------------------- END DATE
  --------------------------------------------->

  <!--  <button mat-icon-button (click)="getData(selectedCentreCode)">-->
  <!--    <mat-icon>search</mat-icon>-->
  <!--  </button>-->

  <!--  <button mat-icon-button (click)="getData(selectedCentreCode)">-->
  <!--    <mat-icon>search</mat-icon>-->
  <!--  </button>-->

  <div class="col-md-1">
    <div class="d-flex  justify-content-start">
      &nbsp;&nbsp;<button permission="Child Report" [permissionTypes]="[PermissionType.VIEW]" mat-mini-fab
                          color="accent"
                          (click)="dynamicQuery()" matTooltip="Search">
      <mat-icon>search</mat-icon>
    </button>&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;
      <button mat-mini-fab color="accent"
              permission="Child Report" [permissionTypes]="[PermissionType.VIEW]" (click)="clearAll()"
              matTooltip="Clear">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <!-- Carry-forward is always ON (mandatory) — no checkbox needed -->

  <!-- ── DATA SOURCE MODE SELECTOR ─────────────────────────────────────── -->
  <div class="col-12 mb-2">
    <div class="d-flex align-items-center gap-2">
      <span class="text-muted small fw-semibold me-1">Data Source:</span>

      <!-- CYCLES MODE button -->
      <button mat-raised-button
              [color]="useAdmissionCycles ? 'primary' : ''"
              [class.mode-active]="useAdmissionCycles"
              [class.mode-inactive]="!useAdmissionCycles"
              (click)="useAdmissionCycles = true"
              matTooltip="Use ALAdmissionCycles collection — one document per stay. Recommended.">
        <mat-icon class="me-1" style="font-size:16px; height:16px; width:16px;">loop</mat-icon>
        Admission Cycles
        <span *ngIf="useAdmissionCycles"
              style="margin-left:6px; background:#fff; color:#1976d2; border-radius:4px; padding:1px 6px; font-size:11px; font-weight:700;">
          ACTIVE
        </span>
      </button>

      <!-- LEGACY MODE button -->
      <button mat-raised-button
              [color]="!useAdmissionCycles ? 'warn' : ''"
              [class.mode-active]="!useAdmissionCycles"
              [class.mode-inactive]="useAdmissionCycles"
              (click)="useAdmissionCycles = false"
              matTooltip="Use ALChild collection — legacy nested admissionData array. Use only to compare / debug.">
        <mat-icon class="me-1" style="font-size:16px; height:16px; width:16px;">history</mat-icon>
        Legacy (ALChild)
        <span *ngIf="!useAdmissionCycles"
              style="margin-left:6px; background:#fff; color:#d32f2f; border-radius:4px; padding:1px 6px; font-size:11px; font-weight:700;">
          ACTIVE
        </span>
      </button>

      <mat-chip *ngIf="useAdmissionCycles"
                style="background:#e8f5e9; color:#2e7d32; font-size:12px; font-weight:600; height:28px;">
        <mat-icon style="font-size:14px; height:14px; width:14px; margin-right:4px;">check_circle</mat-icon>
        Recommended Mode
      </mat-chip>
      <mat-chip *ngIf="!useAdmissionCycles"
                style="background:#fff3e0; color:#e65100; font-size:12px; font-weight:600; height:28px;">
        <mat-icon style="font-size:14px; height:14px; width:14px; margin-right:4px;">warning</mat-icon>
        Legacy — For Comparison Only
      </mat-chip>
    </div>
  </div>

</div>

  <!-- Summary Statistics Section -->
  <div class="row mt-3" *ngIf="summaryStats.totalRecords > 0">
    <div class="col-md-12">
      <mat-card class="summary-card">
        <mat-card-header>
          <mat-card-title>Report Summary</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row">
            <div class="col-md-2">
              <div class="stat-box">
                <div class="stat-value">{{ summaryStats.totalRecords }}</div>
                <div class="stat-label">Total Records</div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="stat-box stat-new">
                <div class="stat-value">{{ summaryStats.newAdmissions }}</div>
                <div class="stat-label">New Admissions</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="stat-box stat-carryforward">
                <div class="stat-value">{{ summaryStats.carryForwardAdmissions }}</div>
                <div class="stat-label">Carry-Forward Admissions</div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="stat-box stat-followup">
                <div class="stat-value">{{ summaryStats.followUpAdmissions }}</div>
                <div class="stat-label">Follow-Up Admissions</div>
              </div>
            </div>
<!--            <div class="col-md-2">-->
<!--              <div class="stat-box stat-discharge">-->
<!--                <div class="stat-value">{{ summaryStats.dischargedInRange }}</div>-->
<!--                <div class="stat-label">Discharged in Range</div>-->
<!--              </div>-->
<!--            </div>-->
          </div>

          <!-- Legend Section — all 4 combinations -->
          <div class="legend-container">
            <div class="legend-title">Row Color Legend</div>
            <div class="legend-items">
              <!-- Case D: New, admitted within range -->
              <div class="legend-item">
                <div class="legend-color" style="background-color: #c8e6c9; border-color: #4caf50;"></div>
                <span class="legend-label">🟢 New Admission (cycle 1, in range)</span>
              </div>
              <!-- Case C: Follow-Up, admitted within range -->
              <div class="legend-item">
                <div class="legend-color" style="background-color: #ffecb3; border-color: #ffc107;"></div>
                <span class="legend-label">🟡 Follow-Up (cycle &gt; 1, in range)</span>
              </div>
              <!-- Case A: New + Carry-Forward -->
              <div class="legend-item">
                <div class="legend-color" style="background-color: #b2ebf2; border-color: #00bcd4;"></div>
                <span class="legend-label">🩵 New + Carry-Forward (cycle 1, admitted before range)</span>
              </div>
              <!-- Case B: Follow-Up + Carry-Forward -->
              <div class="legend-item">
                <div class="legend-color" style="background-color: #e1bee7; border-color: #9c27b0;"></div>
                <span class="legend-label">🟣 Follow-Up + Carry-Forward (cycle &gt; 1, admitted before range)</span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!--    <div class="m-3 d-flex justify-content-between">-->
  <!--        <!*-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; START DATE -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
  <!--        <mat-form-field appearance="outline">-->
  <!--            <mat-label>Search</mat-label>-->
  <!--            <input matInput (keyup)="applyFilter($event)" placeholder="Search Here.." #input>-->
  <!--        </mat-form-field>-->

  <!--      <div>  <button *ngIf="childReport[0].excel" mat-raised-button   class="m-1" (click)="saveComplexObject()" color="primary">  <mat-icon> cloud_download</mat-icon> &nbsp; Download  </button>-->
  <!--      </div>-->
  <!--      -->

  <!--    </div>-->
  <div class="row">

    <div class="note">Use this to generate custom reports or re-arrange columns</div>
    <mat-form-field class="col-md-12" appearance="outline">

      <mat-label>Columns</mat-label>
      <mat-select
        [value]="displayedColumns"
        (selectionChange)="onColumnsSelected($event)"
        multiple
        (opened)="resetColumnFilter()"
      >

      <div class="mat-select-search">
          <input
            matInput
            placeholder="Search columns..."
            [formControl]="columnSearchControl"
            autocomplete="off"
            (keydown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
            (focus)="$event.stopPropagation()"
          >
        </div>

        <mat-option *ngFor="let col of filteredDynamicColumns" [value]="col.value">
          {{ col.label }}
        </mat-option>

      </mat-select>

    </mat-form-field>
  </div>

  <div class="card p-2">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Revised Child Report</h2>
        </li>
        <li class="dropdown m-l-20">
          <label for="search-input"><i class="material-icons search-icon">search</i></label>
          <input id="search-input" placeholder="Search" type="text" class="browser-default search-field"
                 (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <!--      <li>-->
        <!--        <button   mat-mini-fab color="primary" (click)="openAddCarLog()">-->
        <!--          <mat-icon class="col-white" >add</mat-icon>-->
        <!--        </button>-->
        <!--      </li>-->
        <li>
          <div *ngIf="childReport[0].excel" class="export-button m-l-10" matTooltip="XLSX"
               (click)="downloadAllData()" permission="Child Report" [permissionTypes]="[PermissionType.EXCEL]">
            <img src="assets/images/icons/xlsx.png" alt=""/>
          </div>
        </li>
      </ul>
    </div>

    <section class="example-container" tabindex="1">

      <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading...</mat-progress-bar>

      <table mat-table [dataSource]="dataSource" matSort
             class="child-table table table-striped table-bordered" id="child-table" matSortDisableClear
             matSortDirection="desc" cdkDropList cdkDropListOrientation="horizontal"
             (cdkDropListDropped)="drop($event)">
        <!--  POSITION Column-->
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="#"> Num.</th>
          <td mat-cell *matCellDef="let i = index">
            {{
              this.paginator.pageIndex == 0 ? i + 1 : 1 + i + this.paginator.pageIndex *
                this.paginator.pageSize
            }}
          </td>
        </ng-container>
        <!-- Center Column -->
        <!--      <ng-container matColumnDef="centercode">-->
        <!--        <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Center Code </th>-->
        <!--        <td mat-cell *matCellDef="let element"> {{element.centreCode  }} </td>-->
        <!--      </ng-container>-->

        <!--      &lt;!&ndash; Name Column &ndash;&gt;-->
        <!--      <ng-container matColumnDef="childcode">-->
        <!--        <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>Child Code </th>-->
        <!--        <td mat-cell *matCellDef="let element"> {{element.childCode}} </td>-->
        <!--      </ng-container>-->
        <!--      Child Name Column-->
        <ng-container matColumnDef="firstName">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> First Name</th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.childCode"> {{ element.firstName }}
          </td>
        </ng-container>
        <!*--------------------------------------------- Date Of Admission
        --------------------------------------------->
        <!--            <ng-container matColumnDef="DOA">-->
        <!--                <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> DOA </th>-->
        <!--                <td mat-cell *matCellDef="let element"-->
        <!--                    [matTooltip]="element.id"> {{getDate(element.dateOfAdmission)|date:'dd/MM/yyyy'}}  </td>-->
        <!--            </ng-container>-->
        <ng-container matColumnDef="dob">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Date Of Birth</th>
          <td mat-cell *matCellDef="let element"
              [matTooltip]="element.id"> {{ getDate(element.dob)|date:'MM/dd/yyyy' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="eName">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> E Name</th>
          <td mat-cell *matCellDef="let element"
              [matTooltip]="element.id"> {{ element.emergencyContactName1 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="eName2">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> E Name 2</th>
          <td mat-cell *matCellDef="let element"
              [matTooltip]="element.id"> {{ element.emergencyContactName2 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="eRelation">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> E Relation</th>
          <td mat-cell *matCellDef="let element"
              [matTooltip]="element.id"> {{ element.emergencyContactRelation1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="eRelation2">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> E Relation 2</th>
          <td mat-cell *matCellDef="let element"
              [matTooltip]="element.id"> {{ element.emergencyContactRelation2 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="eContact">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> E Number</th>
          <td mat-cell *matCellDef="let element"
              [matTooltip]="element.id"> {{ element.emergencyContactNumber1 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="eContact2">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> E Number 2</th>
          <td mat-cell *matCellDef="let element"
              [matTooltip]="element.id"> {{ element.emergencyContactNumber2 }}
          </td>
        </ng-container>
        <!--        <ng-container matColumnDef="gContact">-->
        <!--          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> G Contact</th>-->
        <!--          <td mat-cell *matCellDef="let element"-->
        <!--              [matTooltip]="element.id"> {{ element.guardians[0].contactNumber }}-->
        <!--          </td>-->
        <!--        </ng-container>-->
        <!--        <ng-container matColumnDef="gSkills">-->
        <!--          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> G Skills</th>-->
        <!--          <td mat-cell *matCellDef="let element"-->
        <!--              [matTooltip]="element.id"> {{ element.guardians[0].skills }}-->
        <!--          </td>-->
        <!--        </ng-container>-->
        <!--      Last Name Column-->
        <ng-container matColumnDef="lastName">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Last Name</th>
          <td mat-cell *matCellDef="let element"> {{ element.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="reason">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Discharge Reason</th>
          <td mat-cell *matCellDef="let element"> {{ element.reason }}</td>
        </ng-container>
        <!-- City Column -->
        <!--        <ng-container matColumnDef="state">-->
        <!--          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> State</th>-->
        <!--          <td mat-cell *matCellDef="let element"> {{ element.state }}</td>-->
        <!--        </ng-container>-->
        <!--        <ng-container matColumnDef="age">-->
        <!--          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Age as Of Date</th>-->
        <!--          <td mat-cell *matCellDef="let element"> {{ element.age }}</td>-->
        <!--        </ng-container>-->
        <!-- City Column -->
        <ng-container matColumnDef="enrolledIn">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Centre</th>
          <td mat-cell *matCellDef="let element"> {{ element.centreCode }}</td>
        </ng-container>
        <ng-container matColumnDef="gender">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Gender</th>
          <td mat-cell *matCellDef="let element"> {{ element.gender }}</td>
        </ng-container>
<!--        <ng-container matColumnDef="diagnosisSelected">-->
<!--          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Diagnosis</th>-->
<!--          <td mat-cell *matCellDef="let element"> {{ element.diagnosisSelected?.[0]?.name }}</td>-->
<!--        </ng-container>-->
        <ng-container matColumnDef="diagnosisSelected">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Diagnosis</th>
          <td mat-cell *matCellDef="let element">
            {{ getDiagnosis(element) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="centreName">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Centre</th>
          <td mat-cell *matCellDef="let element"> {{ element.centreName }}</td>
        </ng-container>
        <ng-container matColumnDef="age">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Age</th>
          <td mat-cell *matCellDef="let element"> {{ element.age }}</td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> State</th>
          <td mat-cell *matCellDef="let element"> {{ element.state }}</td>
        </ng-container>
        <ng-container matColumnDef="city">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> City</th>
          <td mat-cell *matCellDef="let element"> {{ element.city }}</td>
        </ng-container>
        <ng-container matColumnDef="bloodGroup">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Blood Group</th>
          <td mat-cell *matCellDef="let element"> {{ element.bloodGroup }}</td>
        </ng-container>
        <ng-container matColumnDef="hospital">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Hospital</th>
          <td mat-cell *matCellDef="let element"> {{ element.hospital }}</td>
        </ng-container>

        <ng-container matColumnDef="daysOfStay">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
            Days of Stay
          </th>

          <td mat-cell *matCellDef="let element">
            {{ element.daysOfStay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="diagnosis">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Diagnosis</th>
          <td mat-cell *matCellDef="let element"> {{ element.diagnosis }}</td>
        </ng-container>
        <ng-container matColumnDef="middleName">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Middle Name</th>
          <td mat-cell *matCellDef="let element"> {{ element.middleName }}</td>
        </ng-container>
        <ng-container matColumnDef="childCode">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Child Code</th>
          <td mat-cell *matCellDef="let element"> {{ element.childCode }}</td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Type</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.carryForward" class="badge badge-warning"
                  matTooltip="Admitted before date range, not yet discharged OR discharged after end date">
              Carry-Forward
            </span>
            <ng-container *ngIf="!element.carryForward">
              <!-- Cycles mode: use admissionCycle number (cycleNumber 1 = New, >1 = Follow Up) -->
              <!-- Legacy mode: fall back to admissionData array length -->
              <span *ngIf="element.admissionCycle != null">
                {{ element.admissionCycle === 1 ? 'New' : 'Follow Up' }}
              </span>
              <span *ngIf="element.admissionCycle == null">
                {{ (element.admissionData?.length ?? 0) <= 2 ? 'New' : 'Follow Up' }}
              </span>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="dateOfAdmission">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Admission Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.dateOfAdmission?.toDate()|date:'dd-MM-yyyy' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dateOfDischarge">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Discharge Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.dateOfDischarge?.toDate()|date:'dd-MM-yyyy' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="firstAdmission">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> First Admission</th>
          <td mat-cell *matCellDef="let element">
            {{ element.firstAdmission?.toDate()|date:'dd-MM-yyyy' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="firstDischarge">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> First Discharge</th>
          <td mat-cell *matCellDef="let element">
            {{ element.firstDischarge?.toDate()|date:'dd-MM-yyyy' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="admissionCycle">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Admission Cycle</th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.admissionCycle">
            <ng-container>{{ element.admissionCycle }}</ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="totalStayDays">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
            Total Stay (Days)
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.totalStayDays }}
          </td>
        </ng-container>

        <!--      Status Column-->
        <ng-container matColumnDef="status">
          <th mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header> Status</th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.selectUnit">
            <ng-container>{{ element.status }}</ng-container>
          </td>
          <!--      <td mat-cell *matCellDef="let element"> {{element.isAlloted  }} </td>-->
        </ng-container>


        <!-- Symbol Column -->
        <!--    <ng-container matColumnDef="symbol">-->
        <!--      <th mat-header-cell cdkDrag *matHeaderCellDef> Symbol </th>-->
        <!--      <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>-->
        <!--    </ng-container>-->

        <!--     Action-->


        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="getRowClass(row)"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr *matNoDataRow class="mat-row">
          <!--        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>-->
        </tr>


      </table>
    </section>
    <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]"
                   aria-label="Select page of periodic elements">
    </mat-paginator>
  </div>
</div>


<!*--------------------------------------------- DYNAMIC TABLE --------------------------------------------->
<!--<ng-container *ngIf="childData.length>1 && show">-->
<!--<app-dynamic-assessment-table [data]="childData" [show] =show ></app-dynamic-assessment-table>-->
<!--</ng-container>-->
<!--<app-dynamic-assessment-table></app-dynamic-assessment-table>-->
